// extracted by mini-css-extract-plugin
export var filterIncDec = "_dr-0";
export var leftBorder = "_dr-1";
export var rightBorder = "_dr-2";
export var stringInput = "_dr-3";